// Las gildas artesanas del Bar Cabrero — carta real

export const GILDAS = [
  { num: '01', name: 'La Clásica',     img: '/dishes/gilda-clasica.jpg',    desc: 'Aceituna, piparra y anchoa de Santoña.',                                                  spice: 1 },
  { num: '02', name: 'La de Anchoa',   img: '/dishes/gilda-anchoa.jpg',     desc: 'Anchoa y aceituna. Mar del norte en dos bocados.',                                        spice: 0 },
  { num: '03', name: 'La del Boquerón',img: '/dishes/gilda-boqueron.jpg',   desc: 'Boquerón en vinagre y aceituna. Fresca, ácida y adictiva.',                                spice: 0 },
  { num: '04', name: 'El Matrimonio',  img: '/dishes/gilda-matrimonio.jpg', desc: 'Anchoa, boquerón y aceituna. La unión perfecta — del mar y del barril.',                  spice: 0 },
  { num: '05', name: 'La Ibérica',     img: '/dishes/gilda-iberica.jpg',    desc: 'Anchoa, piparra, tomate seco, queso manchego y cecina ibérica. Producto peninsular.',     spice: 1 },
  { num: '06', name: 'La de Pulpo',    img: '/dishes/gilda-pulpo.jpg',      desc: 'Pulpo, anchoa, piparra, huevo de codorniz y pimentón dulce. La más generosa.',            spice: 1 },
  { num: '07', name: 'La de Langostino',img:'/dishes/gilda-langostino.jpg', desc: 'Huevo, langostino, pimiento, aceituna y mayonesa. Marinera y festiva.',                   spice: 0 },
  { num: '08', name: 'La de Queso',    img: '/dishes/gilda-queso.jpg',      desc: 'Aceituna, piparra, anchoa y queso manchego. Untuosa y con carácter.',                     spice: 1 },
  { num: '09', name: 'La de Mejillón', img: '/dishes/gilda-mejillon.jpg',   desc: 'Mejillón en escabeche, anchoa y aceituna. Sabor profundo del Cantábrico.',                spice: 0 },
  { num: '10', name: 'La Verde',       img: '/dishes/gilda-verde.jpg',      desc: 'Aceituna, piparra, cebollita y tomate seco. La más fresca. Sin pescado.',                  spice: 1 },
  { num: '11', name: 'La Ahumada',     img: '/dishes/gilda-ahumada.jpg',    desc: 'Aceituna, piparra y salmón ahumado. Elegante y aromática.',                                spice: 1 },
  { num: '12', name: 'La Picante',     img: '/dishes/gilda-picante.jpg',    desc: 'Anchoa, piparra, aceituna y alegría riojana. Para los valientes.',                         spice: 3 },
];

export const QUIZ_QUESTIONS = [
  {
    q: 'Cuando vienes al Cabrero, ¿qué buscas?',
    opts: [
      { t: 'Lo de toda la vida, sin sorpresas',     v: 'La Clásica' },
      { t: 'Algo elegante con producto peninsular', v: 'La Ibérica' },
      { t: 'Lo más fresco y verde',                  v: 'La Verde' },
      { t: 'Sorpréndeme con algo del mar',           v: 'La de Pulpo' },
    ],
  },
  {
    q: '¿Qué te define como tapeador?',
    opts: [
      { t: 'Mar del norte: anchoa y boquerón', v: 'El Matrimonio' },
      { t: 'Pesca y marisco',                  v: 'La de Langostino' },
      { t: 'Pica que pique',                    v: 'La Picante' },
      { t: 'Sabor ahumado y elegante',          v: 'La Ahumada' },
    ],
  },
  {
    q: '¿Con qué la acompañarías?',
    opts: [
      { t: 'Una caña bien tirada',         v: 'La de Anchoa' },
      { t: 'Un blanco de la Nava bien frío',v: 'La del Boquerón' },
      { t: 'Vermut de grifo del domingo',  v: 'La de Mejillón' },
      { t: 'Una copa de tinto de crianza', v: 'La de Queso' },
    ],
  },
];

export const SPICE_LABELS = ['Sin picante', 'Suave', 'Picante', 'Muy picante'];
